import React, { Component } from "react";
import ResumenCitasAction from "./resumenCitas";

class Index extends Component {
  render() {
    return (
      <div>
        <ResumenCitasAction />
      </div>
    );
  }
}
export default Index;
